import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon';

export class MdbSelectOption {
  constructor(public label: string, public value: string) {
  }
}

export function serializeType<T>(object: T) {
  return function () {
    return object;
  }
}

export function dateTimeFromSql() {
  return value => value instanceof DateTime ? value : DateTime.fromSQL(value);
}

export function arrayFromCommaList() {
  return value => value.split(',').filter(val => val.length > 0);
}

export function convertToBool() {
  return value => value == '1' ? true : false;
}

export interface MdbCompatibleOption {
  label: string;
  value: string;
  // icon: string;
}

export interface AsFormOption {
    id: number;
    name: string;
    value: any;
}

export interface ListItem {
  label: string;
  value: number;
}

export class ListItemOption implements ListItem {
  label: string;
  value: number;

  selected?: boolean = false;
}


export interface Visibility {
  visible: boolean;

  hide();

  show();

  isVisible();

  toggleVisible();
}

export interface SortColumn {
  column: string;
  order: SortOrder;
}

export enum SortOrder {
  Ascending = 'asc',
  Descending = 'desc',
  None = '',
}

export enum ModuleStatus {
  Draft = 0,
  Published = 1,
  Archived = 2,
  Deleted = 4
}

export enum Truth {
  True = 1,
  False = 0
}

export enum StringTruth {
  true = "true",
  false = "false"
}

export var BooleanTruth = {
  "true": true,
  "false": false
}

export class Time {
  static readonly day: number = 60 * 60 * 24;
  static readonly hour: number = 60 * 60;
  static readonly minute: number = 60;
  static readonly second: number = 1;
  static readonly jsSecond: number = 1000;

  static readonly dateFormat: string = 'dd LLL yyyy';
  static readonly dateWithTimeFormat: string = 'dd LLL yyyy hh:mm a';
  static readonly dateWithFullTimeFormat: string = 'dd LLL, yyyy - hh:mm:ss a';

  static readonly momentDateFormat: string = 'DD MMM YYYY';
  static readonly momentDateWithTimeFormat: string = 'DD MMM YYYY hh:mm a';

    static readonly mdbDateFormat: string = 'dd mmm yyyy';
    static readonly mdbFormDateFormat: string = 'dd LLL yyyy';
}

@Pipe({name: 'getDate'})
export class GetDatePipe implements PipeTransform {
  transform(date: any, format: string = 'date'): string {
    if (format == 'date') format = Time.dateFormat;
    if (format == 'datetime') format = Time.dateWithTimeFormat;

    let formattedDate: DateTime;

    try {
      if (typeof date == 'string') formattedDate = DateTime.fromSQL(date);

      else {
        if (typeof date == 'number' && date == parseInt(date.toString())) {
          formattedDate = (DateTime.fromMillis(date * 1000))
        } else {
          formattedDate = date;
        }

      }
    } catch {
      return 'N/A';
    }

    if(window['appGlobals'].constants.userLanguage !=''
      && window['appGlobals'].constants.userLanguage != null
      && typeof window['appGlobals'].constants.userLanguage != 'undefined'){
      if (formattedDate && typeof formattedDate.toFormat === 'function'){
        const date = new Date(formattedDate.toFormat(format));
          switch(window['appGlobals'].constants.userLanguage){
            case 'french':
              const formatter = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" });
              return formatter.format(date);
          }
      } else {
        return 'N/A';
      }
    }

    if (formattedDate && formattedDate.isValid) return formattedDate.toFormat(format);
    else return 'N/A';
  }
}

@Pipe({name: 'getDateTime'})
export class GetDateTimePipe implements PipeTransform {
  transform(date: any): any {
    let dateTime = new Date(date * 1000);
    return new Date(dateTime).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
  }
}

@Pipe({name: 'getDateIso'})
export class GetDateIsoPipe implements PipeTransform {
  transform(date: any): any {

if (date && date != "0000-00-00 00:00:00"){
  let formattedDate: DateTime;
  formattedDate = DateTime.fromSQL(date.split("T")[0])

  return formattedDate.toFormat(Time.dateFormat)
}
 return "";

  }
}

@Pipe({name: 'getHoursMinutes'})
export class GetHoursMinutesPipe implements PipeTransform {
  transform(seconds: any): any {
   let  d = Number(seconds);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    return hDisplay + mDisplay;


  }
}



@Pipe({name: 'getValues'})
export class GetValuesPipe implements PipeTransform {
  transform(map: Map<any, any>): any[] {
    let ret = [];

    map.forEach((val, key) => {
      ret.push({
        key: key,
        val: val
      });
    });

    return ret;
  }
}

@Pipe({name: 'minutesToSeconds'})
export class MinutesToSecondsPipe implements PipeTransform {
    transform(value): string {
        const totalMinutes = Math.floor(value / 60);

        const seconds = value % 60;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return hours + " hours " + minutes + " minutes";
    }
}

export const timezoneList = [
  {
    "label": "Africa/Abidjan",
    "value": "Africa/Abidjan"
  },
  {
    "label": "Africa/Accra",
    "value": "Africa/Accra"
  },
  {
    "label": "Africa/Addis_Ababa",
    "value": "Africa/Addis_Ababa"
  },
  {
    "label": "Africa/Algiers",
    "value": "Africa/Algiers"
  },
  {
    "label": "Africa/Asmara",
    "value": "Africa/Asmara"
  },
  {
    "label": "Africa/Bamako",
    "value": "Africa/Bamako"
  },
  {
    "label": "Africa/Bangui",
    "value": "Africa/Bangui"
  },
  {
    "label": "Africa/Banjul",
    "value": "Africa/Banjul"
  },
  {
    "label": "Africa/Bissau",
    "value": "Africa/Bissau"
  },
  {
    "label": "Africa/Blantyre",
    "value": "Africa/Blantyre"
  },
  {
    "label": "Africa/Brazzaville",
    "value": "Africa/Brazzaville"
  },
  {
    "label": "Africa/Bujumbura",
    "value": "Africa/Bujumbura"
  },
  {
    "label": "Africa/Cairo",
    "value": "Africa/Cairo"
  },
  {
    "label": "Africa/Casablanca",
    "value": "Africa/Casablanca"
  },
  {
    "label": "Africa/Ceuta",
    "value": "Africa/Ceuta"
  },
  {
    "label": "Africa/Conakry",
    "value": "Africa/Conakry"
  },
  {
    "label": "Africa/Dakar",
    "value": "Africa/Dakar"
  },
  {
    "label": "Africa/Dar_es_Salaam",
    "value": "Africa/Dar_es_Salaam"
  },
  {
    "label": "Africa/Djibouti",
    "value": "Africa/Djibouti"
  },
  {
    "label": "Africa/Douala",
    "value": "Africa/Douala"
  },
  {
    "label": "Africa/El_Aaiun",
    "value": "Africa/El_Aaiun"
  },
  {
    "label": "Africa/Freetown",
    "value": "Africa/Freetown"
  },
  {
    "label": "Africa/Gaborone",
    "value": "Africa/Gaborone"
  },
  {
    "label": "Africa/Harare",
    "value": "Africa/Harare"
  },
  {
    "label": "Africa/Johannesburg",
    "value": "Africa/Johannesburg"
  },
  {
    "label": "Africa/Juba",
    "value": "Africa/Juba"
  },
  {
    "label": "Africa/Kampala",
    "value": "Africa/Kampala"
  },
  {
    "label": "Africa/Khartoum",
    "value": "Africa/Khartoum"
  },
  {
    "label": "Africa/Kigali",
    "value": "Africa/Kigali"
  },
  {
    "label": "Africa/Kinshasa",
    "value": "Africa/Kinshasa"
  },
  {
    "label": "Africa/Lagos",
    "value": "Africa/Lagos"
  },
  {
    "label": "Africa/Libreville",
    "value": "Africa/Libreville"
  },
  {
    "label": "Africa/Lome",
    "value": "Africa/Lome"
  },
  {
    "label": "Africa/Luanda",
    "value": "Africa/Luanda"
  },
  {
    "label": "Africa/Lubumbashi",
    "value": "Africa/Lubumbashi"
  },
  {
    "label": "Africa/Lusaka",
    "value": "Africa/Lusaka"
  },
  {
    "label": "Africa/Malabo",
    "value": "Africa/Malabo"
  },
  {
    "label": "Africa/Maputo",
    "value": "Africa/Maputo"
  },
  {
    "label": "Africa/Maseru",
    "value": "Africa/Maseru"
  },
  {
    "label": "Africa/Mbabane",
    "value": "Africa/Mbabane"
  },
  {
    "label": "Africa/Mogadishu",
    "value": "Africa/Mogadishu"
  },
  {
    "label": "Africa/Monrovia",
    "value": "Africa/Monrovia"
  },
  {
    "label": "Africa/Nairobi",
    "value": "Africa/Nairobi"
  },
  {
    "label": "Africa/Ndjamena",
    "value": "Africa/Ndjamena"
  },
  {
    "label": "Africa/Niamey",
    "value": "Africa/Niamey"
  },
  {
    "label": "Africa/Nouakchott",
    "value": "Africa/Nouakchott"
  },
  {
    "label": "Africa/Ouagadougou",
    "value": "Africa/Ouagadougou"
  },
  {
    "label": "Africa/Porto-Novo",
    "value": "Africa/Porto-Novo"
  },
  {
    "label": "Africa/Sao_Tome",
    "value": "Africa/Sao_Tome"
  },
  {
    "label": "Africa/Tripoli",
    "value": "Africa/Tripoli"
  },
  {
    "label": "Africa/Tunis",
    "value": "Africa/Tunis"
  },
  {
    "label": "Africa/Windhoek",
    "value": "Africa/Windhoek"
  },
  {
    "label": "America/Adak",
    "value": "America/Adak"
  },
  {
    "label": "America/Anchorage",
    "value": "America/Anchorage"
  },
  {
    "label": "America/Anguilla",
    "value": "America/Anguilla"
  },
  {
    "label": "America/Antigua",
    "value": "America/Antigua"
  },
  {
    "label": "America/Araguaina",
    "value": "America/Araguaina"
  },
  {
    "label": "America/Argentina/Buenos_Aires",
    "value": "America/Argentina/Buenos_Aires"
  },
  {
    "label": "America/Argentina/Catamarca",
    "value": "America/Argentina/Catamarca"
  },
  {
    "label": "America/Argentina/Cordoba",
    "value": "America/Argentina/Cordoba"
  },
  {
    "label": "America/Argentina/Jujuy",
    "value": "America/Argentina/Jujuy"
  },
  {
    "label": "America/Argentina/La_Rioja",
    "value": "America/Argentina/La_Rioja"
  },
  {
    "label": "America/Argentina/Mendoza",
    "value": "America/Argentina/Mendoza"
  },
  {
    "label": "America/Argentina/Rio_Gallegos",
    "value": "America/Argentina/Rio_Gallegos"
  },
  {
    "label": "America/Argentina/Salta",
    "value": "America/Argentina/Salta"
  },
  {
    "label": "America/Argentina/San_Juan",
    "value": "America/Argentina/San_Juan"
  },
  {
    "label": "America/Argentina/San_Luis",
    "value": "America/Argentina/San_Luis"
  },
  {
    "label": "America/Argentina/Tucuman",
    "value": "America/Argentina/Tucuman"
  },
  {
    "label": "America/Argentina/Ushuaia",
    "value": "America/Argentina/Ushuaia"
  },
  {
    "label": "America/Aruba",
    "value": "America/Aruba"
  },
  {
    "label": "America/Asuncion",
    "value": "America/Asuncion"
  },
  {
    "label": "America/Atikokan",
    "value": "America/Atikokan"
  },
  {
    "label": "America/Bahia",
    "value": "America/Bahia"
  },
  {
    "label": "America/Bahia_Banderas",
    "value": "America/Bahia_Banderas"
  },
  {
    "label": "America/Barbados",
    "value": "America/Barbados"
  },
  {
    "label": "America/Belem",
    "value": "America/Belem"
  },
  {
    "label": "America/Belize",
    "value": "America/Belize"
  },
  {
    "label": "America/Blanc-Sablon",
    "value": "America/Blanc-Sablon"
  },
  {
    "label": "America/Boa_Vista",
    "value": "America/Boa_Vista"
  },
  {
    "label": "America/Bogota",
    "value": "America/Bogota"
  },
  {
    "label": "America/Boise",
    "value": "America/Boise"
  },
  {
    "label": "America/Cambridge_Bay",
    "value": "America/Cambridge_Bay"
  },
  {
    "label": "America/Campo_Grande",
    "value": "America/Campo_Grande"
  },
  {
    "label": "America/Cancun",
    "value": "America/Cancun"
  },
  {
    "label": "America/Caracas",
    "value": "America/Caracas"
  },
  {
    "label": "America/Cayenne",
    "value": "America/Cayenne"
  },
  {
    "label": "America/Cayman",
    "value": "America/Cayman"
  },
  {
    "label": "America/Chicago",
    "value": "America/Chicago"
  },
  {
    "label": "America/Chihuahua",
    "value": "America/Chihuahua"
  },
  {
    "label": "America/Costa_Rica",
    "value": "America/Costa_Rica"
  },
  {
    "label": "America/Cuiaba",
    "value": "America/Cuiaba"
  },
  {
    "label": "America/Curacao",
    "value": "America/Curacao"
  },
  {
    "label": "America/Danmarkshavn",
    "value": "America/Danmarkshavn"
  },
  {
    "label": "America/Dawson",
    "value": "America/Dawson"
  },
  {
    "label": "America/Dawson_Creek",
    "value": "America/Dawson_Creek"
  },
  {
    "label": "America/Denver",
    "value": "America/Denver"
  },
  {
    "label": "America/Detroit",
    "value": "America/Detroit"
  },
  {
    "label": "America/Dominica",
    "value": "America/Dominica"
  },
  {
    "label": "America/Edmonton",
    "value": "America/Edmonton"
  },
  {
    "label": "America/Eirunepe",
    "value": "America/Eirunepe"
  },
  {
    "label": "America/El_Salvador",
    "value": "America/El_Salvador"
  },
  {
    "label": "America/Fortaleza",
    "value": "America/Fortaleza"
  },
  {
    "label": "America/Glace_Bay",
    "value": "America/Glace_Bay"
  },
  {
    "label": "America/Godthab",
    "value": "America/Godthab"
  },
  {
    "label": "America/Goose_Bay",
    "value": "America/Goose_Bay"
  },
  {
    "label": "America/Grand_Turk",
    "value": "America/Grand_Turk"
  },
  {
    "label": "America/Grenada",
    "value": "America/Grenada"
  },
  {
    "label": "America/Guadeloupe",
    "value": "America/Guadeloupe"
  },
  {
    "label": "America/Guatemala",
    "value": "America/Guatemala"
  },
  {
    "label": "America/Guayaquil",
    "value": "America/Guayaquil"
  },
  {
    "label": "America/Guyana",
    "value": "America/Guyana"
  },
  {
    "label": "America/Halifax",
    "value": "America/Halifax"
  },
  {
    "label": "America/Havana",
    "value": "America/Havana"
  },
  {
    "label": "America/Hermosillo",
    "value": "America/Hermosillo"
  },
  {
    "label": "America/Indiana/Indianapolis",
    "value": "America/Indiana/Indianapolis"
  },
  {
    "label": "America/Indiana/Knox",
    "value": "America/Indiana/Knox"
  },
  {
    "label": "America/Indiana/Marengo",
    "value": "America/Indiana/Marengo"
  },
  {
    "label": "America/Indiana/Petersburg",
    "value": "America/Indiana/Petersburg"
  },
  {
    "label": "America/Indiana/Tell_City",
    "value": "America/Indiana/Tell_City"
  },
  {
    "label": "America/Indiana/Vevay",
    "value": "America/Indiana/Vevay"
  },
  {
    "label": "America/Indiana/Vincennes",
    "value": "America/Indiana/Vincennes"
  },
  {
    "label": "America/Indiana/Winamac",
    "value": "America/Indiana/Winamac"
  },
  {
    "label": "America/Inuvik",
    "value": "America/Inuvik"
  },
  {
    "label": "America/Iqaluit",
    "value": "America/Iqaluit"
  },
  {
    "label": "America/Jamaica",
    "value": "America/Jamaica"
  },
  {
    "label": "America/Juneau",
    "value": "America/Juneau"
  },
  {
    "label": "America/Kentucky/Louisville",
    "value": "America/Kentucky/Louisville"
  },
  {
    "label": "America/Kentucky/Monticello",
    "value": "America/Kentucky/Monticello"
  },
  {
    "label": "America/Kralendijk",
    "value": "America/Kralendijk"
  },
  {
    "label": "America/La_Paz",
    "value": "America/La_Paz"
  },
  {
    "label": "America/Lima",
    "value": "America/Lima"
  },
  {
    "label": "America/Los_Angeles",
    "value": "America/Los_Angeles"
  },
  {
    "label": "America/Lower_Princes",
    "value": "America/Lower_Princes"
  },
  {
    "label": "America/Maceio",
    "value": "America/Maceio"
  },
  {
    "label": "America/Managua",
    "value": "America/Managua"
  },
  {
    "label": "America/Manaus",
    "value": "America/Manaus"
  },
  {
    "label": "America/Marigot",
    "value": "America/Marigot"
  },
  {
    "label": "America/Martinique",
    "value": "America/Martinique"
  },
  {
    "label": "America/Matamoros",
    "value": "America/Matamoros"
  },
  {
    "label": "America/Mazatlan",
    "value": "America/Mazatlan"
  },
  {
    "label": "America/Menominee",
    "value": "America/Menominee"
  },
  {
    "label": "America/Merida",
    "value": "America/Merida"
  },
  {
    "label": "America/Metlakatla",
    "value": "America/Metlakatla"
  },
  {
    "label": "America/Mexico_City",
    "value": "America/Mexico_City"
  },
  {
    "label": "America/Miquelon",
    "value": "America/Miquelon"
  },
  {
    "label": "America/Moncton",
    "value": "America/Moncton"
  },
  {
    "label": "America/Monterrey",
    "value": "America/Monterrey"
  },
  {
    "label": "America/Montevideo",
    "value": "America/Montevideo"
  },
  {
    "label": "America/Montreal",
    "value": "America/Montreal"
  },
  {
    "label": "America/Montserrat",
    "value": "America/Montserrat"
  },
  {
    "label": "America/Nassau",
    "value": "America/Nassau"
  },
  {
    "label": "America/New_York",
    "value": "America/New_York"
  },
  {
    "label": "America/Nipigon",
    "value": "America/Nipigon"
  },
  {
    "label": "America/Nome",
    "value": "America/Nome"
  },
  {
    "label": "America/Noronha",
    "value": "America/Noronha"
  },
  {
    "label": "America/North_Dakota/Beulah",
    "value": "America/North_Dakota/Beulah"
  },
  {
    "label": "America/North_Dakota/Center",
    "value": "America/North_Dakota/Center"
  },
  {
    "label": "America/North_Dakota/New_Salem",
    "value": "America/North_Dakota/New_Salem"
  },
  {
    "label": "America/Ojinaga",
    "value": "America/Ojinaga"
  },
  {
    "label": "America/Panama",
    "value": "America/Panama"
  },
  {
    "label": "America/Pangnirtung",
    "value": "America/Pangnirtung"
  },
  {
    "label": "America/Paramaribo",
    "value": "America/Paramaribo"
  },
  {
    "label": "America/Phoenix",
    "value": "America/Phoenix"
  },
  {
    "label": "America/Port-au-Prince",
    "value": "America/Port-au-Prince"
  },
  {
    "label": "America/Port_of_Spain",
    "value": "America/Port_of_Spain"
  },
  {
    "label": "America/Porto_Velho",
    "value": "America/Porto_Velho"
  },
  {
    "label": "America/Puerto_Rico",
    "value": "America/Puerto_Rico"
  },
  {
    "label": "America/Rainy_River",
    "value": "America/Rainy_River"
  },
  {
    "label": "America/Rankin_Inlet",
    "value": "America/Rankin_Inlet"
  },
  {
    "label": "America/Recife",
    "value": "America/Recife"
  },
  {
    "label": "America/Regina",
    "value": "America/Regina"
  },
  {
    "label": "America/Resolute",
    "value": "America/Resolute"
  },
  {
    "label": "America/Rio_Branco",
    "value": "America/Rio_Branco"
  },
  {
    "label": "America/Santa_Isabel",
    "value": "America/Santa_Isabel"
  },
  {
    "label": "America/Santarem",
    "value": "America/Santarem"
  },
  {
    "label": "America/Santiago",
    "value": "America/Santiago"
  },
  {
    "label": "America/Santo_Domingo",
    "value": "America/Santo_Domingo"
  },
  {
    "label": "America/Sao_Paulo",
    "value": "America/Sao_Paulo"
  },
  {
    "label": "America/Scoresbysund",
    "value": "America/Scoresbysund"
  },
  {
    "label": "America/Shiprock",
    "value": "America/Shiprock"
  },
  {
    "label": "America/Sitka",
    "value": "America/Sitka"
  },
  {
    "label": "America/St_Barthelemy",
    "value": "America/St_Barthelemy"
  },
  {
    "label": "America/St_Johns",
    "value": "America/St_Johns"
  },
  {
    "label": "America/St_Kitts",
    "value": "America/St_Kitts"
  },
  {
    "label": "America/St_Lucia",
    "value": "America/St_Lucia"
  },
  {
    "label": "America/St_Thomas",
    "value": "America/St_Thomas"
  },
  {
    "label": "America/St_Vincent",
    "value": "America/St_Vincent"
  },
  {
    "label": "America/Swift_Current",
    "value": "America/Swift_Current"
  },
  {
    "label": "America/Tegucigalpa",
    "value": "America/Tegucigalpa"
  },
  {
    "label": "America/Thule",
    "value": "America/Thule"
  },
  {
    "label": "America/Thunder_Bay",
    "value": "America/Thunder_Bay"
  },
  {
    "label": "America/Tijuana",
    "value": "America/Tijuana"
  },
  {
    "label": "America/Toronto",
    "value": "America/Toronto"
  },
  {
    "label": "America/Tortola",
    "value": "America/Tortola"
  },
  {
    "label": "America/Vancouver",
    "value": "America/Vancouver"
  },
  {
    "label": "America/Whitehorse",
    "value": "America/Whitehorse"
  },
  {
    "label": "America/Winnipeg",
    "value": "America/Winnipeg"
  },
  {
    "label": "America/Yakutat",
    "value": "America/Yakutat"
  },
  {
    "label": "America/Yellowknife",
    "value": "America/Yellowknife"
  },
  {
    "label": "Antarctica/Casey",
    "value": "Antarctica/Casey"
  },
  {
    "label": "Antarctica/Davis",
    "value": "Antarctica/Davis"
  },
  {
    "label": "Antarctica/DumontDUrville",
    "value": "Antarctica/DumontDUrville"
  },
  {
    "label": "Antarctica/Macquarie",
    "value": "Antarctica/Macquarie"
  },
  {
    "label": "Antarctica/Mawson",
    "value": "Antarctica/Mawson"
  },
  {
    "label": "Antarctica/McMurdo",
    "value": "Antarctica/McMurdo"
  },
  {
    "label": "Antarctica/Palmer",
    "value": "Antarctica/Palmer"
  },
  {
    "label": "Antarctica/Rothera",
    "value": "Antarctica/Rothera"
  },
  {
    "label": "Antarctica/South_Pole",
    "value": "Antarctica/South_Pole"
  },
  {
    "label": "Antarctica/Syowa",
    "value": "Antarctica/Syowa"
  },
  {
    "label": "Antarctica/Vostok",
    "value": "Antarctica/Vostok"
  },
  {
    "label": "Arctic/Longyearbyen",
    "value": "Arctic/Longyearbyen"
  },
  {
    "label": "Asia/Aden",
    "value": "Asia/Aden"
  },
  {
    "label": "Asia/Almaty",
    "value": "Asia/Almaty"
  },
  {
    "label": "Asia/Amman",
    "value": "Asia/Amman"
  },
  {
    "label": "Asia/Anadyr",
    "value": "Asia/Anadyr"
  },
  {
    "label": "Asia/Aqtau",
    "value": "Asia/Aqtau"
  },
  {
    "label": "Asia/Aqtobe",
    "value": "Asia/Aqtobe"
  },
  {
    "label": "Asia/Ashgabat",
    "value": "Asia/Ashgabat"
  },
  {
    "label": "Asia/Baghdad",
    "value": "Asia/Baghdad"
  },
  {
    "label": "Asia/Bahrain",
    "value": "Asia/Bahrain"
  },
  {
    "label": "Asia/Baku",
    "value": "Asia/Baku"
  },
  {
    "label": "Asia/Bangkok",
    "value": "Asia/Bangkok"
  },
  {
    "label": "Asia/Beirut",
    "value": "Asia/Beirut"
  },
  {
    "label": "Asia/Bishkek",
    "value": "Asia/Bishkek"
  },
  {
    "label": "Asia/Brunei",
    "value": "Asia/Brunei"
  },
  {
    "label": "Asia/Choibalsan",
    "value": "Asia/Choibalsan"
  },
  {
    "label": "Asia/Chongqing",
    "value": "Asia/Chongqing"
  },
  {
    "label": "Asia/Colombo",
    "value": "Asia/Colombo"
  },
  {
    "label": "Asia/Damascus",
    "value": "Asia/Damascus"
  },
  {
    "label": "Asia/Dhaka",
    "value": "Asia/Dhaka"
  },
  {
    "label": "Asia/Dili",
    "value": "Asia/Dili"
  },
  {
    "label": "Asia/Dubai",
    "value": "Asia/Dubai"
  },
  {
    "label": "Asia/Dushanbe",
    "value": "Asia/Dushanbe"
  },
  {
    "label": "Asia/Gaza",
    "value": "Asia/Gaza"
  },
  {
    "label": "Asia/Harbin",
    "value": "Asia/Harbin"
  },
  {
    "label": "Asia/Hebron",
    "value": "Asia/Hebron"
  },
  {
    "label": "Asia/Ho_Chi_Minh",
    "value": "Asia/Ho_Chi_Minh"
  },
  {
    "label": "Asia/Hong_Kong",
    "value": "Asia/Hong_Kong"
  },
  {
    "label": "Asia/Hovd",
    "value": "Asia/Hovd"
  },
  {
    "label": "Asia/Irkutsk",
    "value": "Asia/Irkutsk"
  },
  {
    "label": "Asia/Jakarta",
    "value": "Asia/Jakarta"
  },
  {
    "label": "Asia/Jayapura",
    "value": "Asia/Jayapura"
  },
  {
    "label": "Asia/Jerusalem",
    "value": "Asia/Jerusalem"
  },
  {
    "label": "Asia/Kabul",
    "value": "Asia/Kabul"
  },
  {
    "label": "Asia/Kamchatka",
    "value": "Asia/Kamchatka"
  },
  {
    "label": "Asia/Karachi",
    "value": "Asia/Karachi"
  },
  {
    "label": "Asia/Kashgar",
    "value": "Asia/Kashgar"
  },
  {
    "label": "Asia/Kathmandu",
    "value": "Asia/Kathmandu"
  },
  {
    "label": "Asia/Kolkata",
    "value": "Asia/Kolkata"
  },
  {
    "label": "Asia/Krasnoyarsk",
    "value": "Asia/Krasnoyarsk"
  },
  {
    "label": "Asia/Kuala_Lumpur",
    "value": "Asia/Kuala_Lumpur"
  },
  {
    "label": "Asia/Kuching",
    "value": "Asia/Kuching"
  },
  {
    "label": "Asia/Kuwait",
    "value": "Asia/Kuwait"
  },
  {
    "label": "Asia/Macau",
    "value": "Asia/Macau"
  },
  {
    "label": "Asia/Magadan",
    "value": "Asia/Magadan"
  },
  {
    "label": "Asia/Makassar",
    "value": "Asia/Makassar"
  },
  {
    "label": "Asia/Manila",
    "value": "Asia/Manila"
  },
  {
    "label": "Asia/Muscat",
    "value": "Asia/Muscat"
  },
  {
    "label": "Asia/Nicosia",
    "value": "Asia/Nicosia"
  },
  {
    "label": "Asia/Novokuznetsk",
    "value": "Asia/Novokuznetsk"
  },
  {
    "label": "Asia/Novosibirsk",
    "value": "Asia/Novosibirsk"
  },
  {
    "label": "Asia/Omsk",
    "value": "Asia/Omsk"
  },
  {
    "label": "Asia/Oral",
    "value": "Asia/Oral"
  },
  {
    "label": "Asia/Phnom_Penh",
    "value": "Asia/Phnom_Penh"
  },
  {
    "label": "Asia/Pontianak",
    "value": "Asia/Pontianak"
  },
  {
    "label": "Asia/Pyongyang",
    "value": "Asia/Pyongyang"
  },
  {
    "label": "Asia/Qatar",
    "value": "Asia/Qatar"
  },
  {
    "label": "Asia/Qyzylorda",
    "value": "Asia/Qyzylorda"
  },
  {
    "label": "Asia/Rangoon",
    "value": "Asia/Rangoon"
  },
  {
    "label": "Asia/Riyadh",
    "value": "Asia/Riyadh"
  },
  {
    "label": "Asia/Sakhalin",
    "value": "Asia/Sakhalin"
  },
  {
    "label": "Asia/Samarkand",
    "value": "Asia/Samarkand"
  },
  {
    "label": "Asia/Seoul",
    "value": "Asia/Seoul"
  },
  {
    "label": "Asia/Shanghai",
    "value": "Asia/Shanghai"
  },
  {
    "label": "Asia/Singapore",
    "value": "Asia/Singapore"
  },
  {
    "label": "Asia/Taipei",
    "value": "Asia/Taipei"
  },
  {
    "label": "Asia/Tashkent",
    "value": "Asia/Tashkent"
  },
  {
    "label": "Asia/Tbilisi",
    "value": "Asia/Tbilisi"
  },
  {
    "label": "Asia/Tehran",
    "value": "Asia/Tehran"
  },
  {
    "label": "Asia/Thimphu",
    "value": "Asia/Thimphu"
  },
  {
    "label": "Asia/Tokyo",
    "value": "Asia/Tokyo"
  },
  {
    "label": "Asia/Ulaanbaatar",
    "value": "Asia/Ulaanbaatar"
  },
  {
    "label": "Asia/Urumqi",
    "value": "Asia/Urumqi"
  },
  {
    "label": "Asia/Vientiane",
    "value": "Asia/Vientiane"
  },
  {
    "label": "Asia/Vladivostok",
    "value": "Asia/Vladivostok"
  },
  {
    "label": "Asia/Yakutsk",
    "value": "Asia/Yakutsk"
  },
  {
    "label": "Asia/Yekaterinburg",
    "value": "Asia/Yekaterinburg"
  },
  {
    "label": "Asia/Yerevan",
    "value": "Asia/Yerevan"
  },
  {
    "label": "Atlantic/Azores",
    "value": "Atlantic/Azores"
  },
  {
    "label": "Atlantic/Bermuda",
    "value": "Atlantic/Bermuda"
  },
  {
    "label": "Atlantic/Canary",
    "value": "Atlantic/Canary"
  },
  {
    "label": "Atlantic/Cape_Verde",
    "value": "Atlantic/Cape_Verde"
  },
  {
    "label": "Atlantic/Faroe",
    "value": "Atlantic/Faroe"
  },
  {
    "label": "Atlantic/Madeira",
    "value": "Atlantic/Madeira"
  },
  {
    "label": "Atlantic/Reykjavik",
    "value": "Atlantic/Reykjavik"
  },
  {
    "label": "Atlantic/South_Georgia",
    "value": "Atlantic/South_Georgia"
  },
  {
    "label": "Atlantic/St_Helena",
    "value": "Atlantic/St_Helena"
  },
  {
    "label": "Atlantic/Stanley",
    "value": "Atlantic/Stanley"
  },
  {
    "label": "Australia/Adelaide",
    "value": "Australia/Adelaide"
  },
  {
    "label": "Australia/Brisbane",
    "value": "Australia/Brisbane"
  },
  {
    "label": "Australia/Broken_Hill",
    "value": "Australia/Broken_Hill"
  },
  {
    "label": "Australia/Currie",
    "value": "Australia/Currie"
  },
  {
    "label": "Australia/Darwin",
    "value": "Australia/Darwin"
  },
  {
    "label": "Australia/Eucla",
    "value": "Australia/Eucla"
  },
  {
    "label": "Australia/Hobart",
    "value": "Australia/Hobart"
  },
  {
    "label": "Australia/Lindeman",
    "value": "Australia/Lindeman"
  },
  {
    "label": "Australia/Lord_Howe",
    "value": "Australia/Lord_Howe"
  },
  {
    "label": "Australia/Melbourne",
    "value": "Australia/Melbourne"
  },
  {
    "label": "Australia/Perth",
    "value": "Australia/Perth"
  },
  {
    "label": "Australia/Sydney",
    "value": "Australia/Sydney"
  },
  {
    "label": "Europe/Amsterdam",
    "value": "Europe/Amsterdam"
  },
  {
    "label": "Europe/Andorra",
    "value": "Europe/Andorra"
  },
  {
    "label": "Europe/Athens",
    "value": "Europe/Athens"
  },
  {
    "label": "Europe/Belgrade",
    "value": "Europe/Belgrade"
  },
  {
    "label": "Europe/Berlin",
    "value": "Europe/Berlin"
  },
  {
    "label": "Europe/Bratislava",
    "value": "Europe/Bratislava"
  },
  {
    "label": "Europe/Brussels",
    "value": "Europe/Brussels"
  },
  {
    "label": "Europe/Bucharest",
    "value": "Europe/Bucharest"
  },
  {
    "label": "Europe/Budapest",
    "value": "Europe/Budapest"
  },
  {
    "label": "Europe/Chisinau",
    "value": "Europe/Chisinau"
  },
  {
    "label": "Europe/Copenhagen",
    "value": "Europe/Copenhagen"
  },
  {
    "label": "Europe/Dublin",
    "value": "Europe/Dublin"
  },
  {
    "label": "Europe/Gibraltar",
    "value": "Europe/Gibraltar"
  },
  {
    "label": "Europe/Guernsey",
    "value": "Europe/Guernsey"
  },
  {
    "label": "Europe/Helsinki",
    "value": "Europe/Helsinki"
  },
  {
    "label": "Europe/Isle_of_Man",
    "value": "Europe/Isle_of_Man"
  },
  {
    "label": "Europe/Istanbul",
    "value": "Europe/Istanbul"
  },
  {
    "label": "Europe/Jersey",
    "value": "Europe/Jersey"
  },
  {
    "label": "Europe/Kaliningrad",
    "value": "Europe/Kaliningrad"
  },
  {
    "label": "Europe/Kiev",
    "value": "Europe/Kiev"
  },
  {
    "label": "Europe/Lisbon",
    "value": "Europe/Lisbon"
  },
  {
    "label": "Europe/Ljubljana",
    "value": "Europe/Ljubljana"
  },
  {
    "label": "Europe/London",
    "value": "Europe/London"
  },
  {
    "label": "Europe/Luxembourg",
    "value": "Europe/Luxembourg"
  },
  {
    "label": "Europe/Madrid",
    "value": "Europe/Madrid"
  },
  {
    "label": "Europe/Malta",
    "value": "Europe/Malta"
  },
  {
    "label": "Europe/Mariehamn",
    "value": "Europe/Mariehamn"
  },
  {
    "label": "Europe/Minsk",
    "value": "Europe/Minsk"
  },
  {
    "label": "Europe/Monaco",
    "value": "Europe/Monaco"
  },
  {
    "label": "Europe/Moscow",
    "value": "Europe/Moscow"
  },
  {
    "label": "Europe/Oslo",
    "value": "Europe/Oslo"
  },
  {
    "label": "Europe/Paris",
    "value": "Europe/Paris"
  },
  {
    "label": "Europe/Podgorica",
    "value": "Europe/Podgorica"
  },
  {
    "label": "Europe/Prague",
    "value": "Europe/Prague"
  },
  {
    "label": "Europe/Riga",
    "value": "Europe/Riga"
  },
  {
    "label": "Europe/Rome",
    "value": "Europe/Rome"
  },
  {
    "label": "Europe/Samara",
    "value": "Europe/Samara"
  },
  {
    "label": "Europe/San_Marino",
    "value": "Europe/San_Marino"
  },
  {
    "label": "Europe/Sarajevo",
    "value": "Europe/Sarajevo"
  },
  {
    "label": "Europe/Simferopol",
    "value": "Europe/Simferopol"
  },
  {
    "label": "Europe/Skopje",
    "value": "Europe/Skopje"
  },
  {
    "label": "Europe/Sofia",
    "value": "Europe/Sofia"
  },
  {
    "label": "Europe/Stockholm",
    "value": "Europe/Stockholm"
  },
  {
    "label": "Europe/Tallinn",
    "value": "Europe/Tallinn"
  },
  {
    "label": "Europe/Tirane",
    "value": "Europe/Tirane"
  },
  {
    "label": "Europe/Uzhgorod",
    "value": "Europe/Uzhgorod"
  },
  {
    "label": "Europe/Vaduz",
    "value": "Europe/Vaduz"
  },
  {
    "label": "Europe/Vatican",
    "value": "Europe/Vatican"
  },
  {
    "label": "Europe/Vienna",
    "value": "Europe/Vienna"
  },
  {
    "label": "Europe/Vilnius",
    "value": "Europe/Vilnius"
  },
  {
    "label": "Europe/Volgograd",
    "value": "Europe/Volgograd"
  },
  {
    "label": "Europe/Warsaw",
    "value": "Europe/Warsaw"
  },
  {
    "label": "Europe/Zagreb",
    "value": "Europe/Zagreb"
  },
  {
    "label": "Europe/Zaporozhye",
    "value": "Europe/Zaporozhye"
  },
  {
    "label": "Europe/Zurich",
    "value": "Europe/Zurich"
  },
  {
    "label": "Indian/Antananarivo",
    "value": "Indian/Antananarivo"
  },
  {
    "label": "Indian/Chagos",
    "value": "Indian/Chagos"
  },
  {
    "label": "Indian/Christmas",
    "value": "Indian/Christmas"
  },
  {
    "label": "Indian/Cocos",
    "value": "Indian/Cocos"
  },
  {
    "label": "Indian/Comoro",
    "value": "Indian/Comoro"
  },
  {
    "label": "Indian/Kerguelen",
    "value": "Indian/Kerguelen"
  },
  {
    "label": "Indian/Mahe",
    "value": "Indian/Mahe"
  },
  {
    "label": "Indian/Maldives",
    "value": "Indian/Maldives"
  },
  {
    "label": "Indian/Mauritius",
    "value": "Indian/Mauritius"
  },
  {
    "label": "Indian/Mayotte",
    "value": "Indian/Mayotte"
  },
  {
    "label": "Indian/Reunion",
    "value": "Indian/Reunion"
  },
  {
    "label": "Pacific/Apia",
    "value": "Pacific/Apia"
  },
  {
    "label": "Pacific/Auckland",
    "value": "Pacific/Auckland"
  },
  {
    "label": "Pacific/Chatham",
    "value": "Pacific/Chatham"
  },
  {
    "label": "Pacific/Chuuk",
    "value": "Pacific/Chuuk"
  },
  {
    "label": "Pacific/Easter",
    "value": "Pacific/Easter"
  },
  {
    "label": "Pacific/Efate",
    "value": "Pacific/Efate"
  },
  {
    "label": "Pacific/Enderbury",
    "value": "Pacific/Enderbury"
  },
  {
    "label": "Pacific/Fakaofo",
    "value": "Pacific/Fakaofo"
  },
  {
    "label": "Pacific/Fiji",
    "value": "Pacific/Fiji"
  },
  {
    "label": "Pacific/Funafuti",
    "value": "Pacific/Funafuti"
  },
  {
    "label": "Pacific/Galapagos",
    "value": "Pacific/Galapagos"
  },
  {
    "label": "Pacific/Gambier",
    "value": "Pacific/Gambier"
  },
  {
    "label": "Pacific/Guadalcanal",
    "value": "Pacific/Guadalcanal"
  },
  {
    "label": "Pacific/Guam",
    "value": "Pacific/Guam"
  },
  {
    "label": "Pacific/Honolulu",
    "value": "Pacific/Honolulu"
  },
  {
    "label": "Pacific/Johnston",
    "value": "Pacific/Johnston"
  },
  {
    "label": "Pacific/Kiritimati",
    "value": "Pacific/Kiritimati"
  },
  {
    "label": "Pacific/Kosrae",
    "value": "Pacific/Kosrae"
  },
  {
    "label": "Pacific/Kwajalein",
    "value": "Pacific/Kwajalein"
  },
  {
    "label": "Pacific/Majuro",
    "value": "Pacific/Majuro"
  },
  {
    "label": "Pacific/Marquesas",
    "value": "Pacific/Marquesas"
  },
  {
    "label": "Pacific/Midway",
    "value": "Pacific/Midway"
  },
  {
    "label": "Pacific/Nauru",
    "value": "Pacific/Nauru"
  },
  {
    "label": "Pacific/Niue",
    "value": "Pacific/Niue"
  },
  {
    "label": "Pacific/Norfolk",
    "value": "Pacific/Norfolk"
  },
  {
    "label": "Pacific/Noumea",
    "value": "Pacific/Noumea"
  },
  {
    "label": "Pacific/Pago_Pago",
    "value": "Pacific/Pago_Pago"
  },
  {
    "label": "Pacific/Palau",
    "value": "Pacific/Palau"
  },
  {
    "label": "Pacific/Pitcairn",
    "value": "Pacific/Pitcairn"
  },
  {
    "label": "Pacific/Pohnpei",
    "value": "Pacific/Pohnpei"
  },
  {
    "label": "Pacific/Port_Moresby",
    "value": "Pacific/Port_Moresby"
  },
  {
    "label": "Pacific/Rarotonga",
    "value": "Pacific/Rarotonga"
  },
  {
    "label": "Pacific/Saipan",
    "value": "Pacific/Saipan"
  },
  {
    "label": "Pacific/Tahiti",
    "value": "Pacific/Tahiti"
  },
  {
    "label": "Pacific/Tarawa",
    "value": "Pacific/Tarawa"
  },
  {
    "label": "Pacific/Tongatapu",
    "value": "Pacific/Tongatapu"
  },
  {
    "label": "Pacific/Wake",
    "value": "Pacific/Wake"
  },
  {
    "label": "Pacific/Wallis",
    "value": "Pacific/Wallis"
  },
  {
    "label": "UTC",
    "value": "UTC"
  },
];

const _charmap = [
  ['&nbsp;', '&#160;', true, 'no-break space'],
  ['&amp;', '&#38;', true, 'ampersand'],
  ['&quot;', '&#34;', true, 'quotation mark'],
// finance
  ['&cent;', '&#162;', true, 'cent sign'],
  ['&euro;', '&#8364;', true, 'euro sign'],
  ['&pound;', '&#163;', true, 'pound sign'],
  ['&yen;', '&#165;', true, 'yen sign'],
// signs
  ['&copy;', '&#169;', true, 'copyright sign'],
  ['&reg;', '&#174;', true, 'registered sign'],
  ['&trade;', '&#8482;', true, 'trade mark sign'],
  ['&permil;', '&#8240;', true, 'per mille sign'],
  ['&micro;', '&#181;', true, 'micro sign'],
  ['&middot;', '&#183;', true, 'middle dot'],
  ['&bull;', '&#8226;', true, 'bullet'],
  ['&hellip;', '&#8230;', true, 'three dot leader'],
  ['&prime;', '&#8242;', true, 'minutes / feet'],
  ['&Prime;', '&#8243;', true, 'seconds / inches'],
  ['&sect;', '&#167;', true, 'section sign'],
  ['&para;', '&#182;', true, 'paragraph sign'],
  ['&szlig;', '&#223;', true, 'sharp s / ess-zed'],
// quotations
  ['&lsaquo;', '&#8249;', true, 'single left-pointing angle quotation mark'],
  ['&rsaquo;', '&#8250;', true, 'single right-pointing angle quotation mark'],
  ['&laquo;', '&#171;', true, 'left pointing guillemet'],
  ['&raquo;', '&#187;', true, 'right pointing guillemet'],
  ['&lsquo;', '&#8216;', true, 'left single quotation mark'],
  ['&rsquo;', '&#8217;', true, 'right single quotation mark'],
  ['&ldquo;', '&#8220;', true, 'left double quotation mark'],
  ['&rdquo;', '&#8221;', true, 'right double quotation mark'],
  ['&sbquo;', '&#8218;', true, 'single low-9 quotation mark'],
  ['&bdquo;', '&#8222;', true, 'double low-9 quotation mark'],
  ['&lt;', '&#60;', true, 'less-than sign'],
  ['&gt;', '&#62;', true, 'greater-than sign'],
  ['&le;', '&#8804;', true, 'less-than or equal to'],
  ['&ge;', '&#8805;', true, 'greater-than or equal to'],
  ['&ndash;', '&#8211;', true, 'en dash'],
  ['&mdash;', '&#8212;', true, 'em dash'],
  ['&macr;', '&#175;', true, 'macron'],
  ['&oline;', '&#8254;', true, 'overline'],
  ['&curren;', '&#164;', true, 'currency sign'],
  ['&brvbar;', '&#166;', true, 'broken bar'],
  ['&uml;', '&#168;', true, 'diaeresis'],
  ['&iexcl;', '&#161;', true, 'inverted exclamation mark'],
  ['&iquest;', '&#191;', true, 'turned question mark'],
  ['&circ;', '&#710;', true, 'circumflex accent'],
  ['&tilde;', '&#732;', true, 'small tilde'],
  ['&deg;', '&#176;', true, 'degree sign'],
  ['&minus;', '&#8722;', true, 'minus sign'],
  ['&plusmn;', '&#177;', true, 'plus-minus sign'],
  ['&divide;', '&#247;', true, 'division sign'],
  ['&frasl;', '&#8260;', true, 'fraction slash'],
  ['&times;', '&#215;', true, 'multiplication sign'],
  ['&sup1;', '&#185;', true, 'superscript one'],
  ['&sup2;', '&#178;', true, 'superscript two'],
  ['&sup3;', '&#179;', true, 'superscript three'],
  ['&frac14;', '&#188;', true, 'fraction one quarter'],
  ['&frac12;', '&#189;', true, 'fraction one half'],
  ['&frac34;', '&#190;', true, 'fraction three quarters'],
// math / logical
  ['&fnof;', '&#402;', true, 'function / florin'],
  ['&int;', '&#8747;', true, 'integral'],
  ['&sum;', '&#8721;', true, 'n-ary sumation'],
  ['&infin;', '&#8734;', true, 'infinity'],
  ['&radic;', '&#8730;', true, 'square root'],
  ['&sim;', '&#8764;', false, 'similar to'],
  ['&cong;', '&#8773;', false, 'approximately equal to'],
  ['&asymp;', '&#8776;', true, 'almost equal to'],
  ['&ne;', '&#8800;', true, 'not equal to'],
  ['&equiv;', '&#8801;', true, 'identical to'],
  ['&isin;', '&#8712;', false, 'element of'],
  ['&notin;', '&#8713;', false, 'not an element of'],
  ['&ni;', '&#8715;', false, 'contains as member'],
  ['&prod;', '&#8719;', true, 'n-ary product'],
  ['&and;', '&#8743;', false, 'logical and'],
  ['&or;', '&#8744;', false, 'logical or'],
  ['&not;', '&#172;', true, 'not sign'],
  ['&cap;', '&#8745;', true, 'intersection'],
  ['&cup;', '&#8746;', false, 'union'],
  ['&part;', '&#8706;', true, 'partial differential'],
  ['&forall;', '&#8704;', false, 'for all'],
  ['&exist;', '&#8707;', false, 'there exists'],
  ['&empty;', '&#8709;', false, 'diameter'],
  ['&nabla;', '&#8711;', false, 'backward difference'],
  ['&lowast;', '&#8727;', false, 'asterisk operator'],
  ['&prop;', '&#8733;', false, 'proportional to'],
  ['&ang;', '&#8736;', false, 'angle'],
// undefined
  ['&acute;', '&#180;', true, 'acute accent'],
  ['&cedil;', '&#184;', true, 'cedilla'],
  ['&ordf;', '&#170;', true, 'feminine ordinal indicator'],
  ['&ordm;', '&#186;', true, 'masculine ordinal indicator'],
  ['&dagger;', '&#8224;', true, 'dagger'],
  ['&Dagger;', '&#8225;', true, 'double dagger'],
// alphabetical special chars
  ['&Agrave;', '&#192;', true, 'A - grave'],
  ['&Aacute;', '&#193;', true, 'A - acute'],
  ['&Acirc;', '&#194;', true, 'A - circumflex'],
  ['&Atilde;', '&#195;', true, 'A - tilde'],
  ['&Auml;', '&#196;', true, 'A - diaeresis'],
  ['&Aring;', '&#197;', true, 'A - ring above'],
  ['&AElig;', '&#198;', true, 'ligature AE'],
  ['&Ccedil;', '&#199;', true, 'C - cedilla'],
  ['&Egrave;', '&#200;', true, 'E - grave'],
  ['&Eacute;', '&#201;', true, 'E - acute'],
  ['&Ecirc;', '&#202;', true, 'E - circumflex'],
  ['&Euml;', '&#203;', true, 'E - diaeresis'],
  ['&Igrave;', '&#204;', true, 'I - grave'],
  ['&Iacute;', '&#205;', true, 'I - acute'],
  ['&Icirc;', '&#206;', true, 'I - circumflex'],
  ['&Iuml;', '&#207;', true, 'I - diaeresis'],
  ['&ETH;', '&#208;', true, 'ETH'],
  ['&Ntilde;', '&#209;', true, 'N - tilde'],
  ['&Ograve;', '&#210;', true, 'O - grave'],
  ['&Oacute;', '&#211;', true, 'O - acute'],
  ['&Ocirc;', '&#212;', true, 'O - circumflex'],
  ['&Otilde;', '&#213;', true, 'O - tilde'],
  ['&Ouml;', '&#214;', true, 'O - diaeresis'],
  ['&Oslash;', '&#216;', true, 'O - slash'],
  ['&OElig;', '&#338;', true, 'ligature OE'],
  ['&Scaron;', '&#352;', true, 'S - caron'],
  ['&Ugrave;', '&#217;', true, 'U - grave'],
  ['&Uacute;', '&#218;', true, 'U - acute'],
  ['&Ucirc;', '&#219;', true, 'U - circumflex'],
  ['&Uuml;', '&#220;', true, 'U - diaeresis'],
  ['&Yacute;', '&#221;', true, 'Y - acute'],
  ['&Yuml;', '&#376;', true, 'Y - diaeresis'],
  ['&THORN;', '&#222;', true, 'THORN'],
  ['&agrave;', '&#224;', true, 'a - grave'],
  ['&aacute;', '&#225;', true, 'a - acute'],
  ['&acirc;', '&#226;', true, 'a - circumflex'],
  ['&atilde;', '&#227;', true, 'a - tilde'],
  ['&auml;', '&#228;', true, 'a - diaeresis'],
  ['&aring;', '&#229;', true, 'a - ring above'],
  ['&aelig;', '&#230;', true, 'ligature ae'],
  ['&ccedil;', '&#231;', true, 'c - cedilla'],
  ['&egrave;', '&#232;', true, 'e - grave'],
  ['&eacute;', '&#233;', true, 'e - acute'],
  ['&ecirc;', '&#234;', true, 'e - circumflex'],
  ['&euml;', '&#235;', true, 'e - diaeresis'],
  ['&igrave;', '&#236;', true, 'i - grave'],
  ['&iacute;', '&#237;', true, 'i - acute'],
  ['&icirc;', '&#238;', true, 'i - circumflex'],
  ['&iuml;', '&#239;', true, 'i - diaeresis'],
  ['&eth;', '&#240;', true, 'eth'],
  ['&ntilde;', '&#241;', true, 'n - tilde'],
  ['&ograve;', '&#242;', true, 'o - grave'],
  ['&oacute;', '&#243;', true, 'o - acute'],
  ['&ocirc;', '&#244;', true, 'o - circumflex'],
  ['&otilde;', '&#245;', true, 'o - tilde'],
  ['&ouml;', '&#246;', true, 'o - diaeresis'],
  ['&oslash;', '&#248;', true, 'o slash'],
  ['&oelig;', '&#339;', true, 'ligature oe'],
  ['&scaron;', '&#353;', true, 's - caron'],
  ['&ugrave;', '&#249;', true, 'u - grave'],
  ['&uacute;', '&#250;', true, 'u - acute'],
  ['&ucirc;', '&#251;', true, 'u - circumflex'],
  ['&uuml;', '&#252;', true, 'u - diaeresis'],
  ['&yacute;', '&#253;', true, 'y - acute'],
  ['&thorn;', '&#254;', true, 'thorn'],
  ['&yuml;', '&#255;', true, 'y - diaeresis'],
  ['&Alpha;', '&#913;', true, 'Alpha'],
  ['&Beta;', '&#914;', true, 'Beta'],
  ['&Gamma;', '&#915;', true, 'Gamma'],
  ['&Delta;', '&#916;', true, 'Delta'],
  ['&Epsilon;', '&#917;', true, 'Epsilon'],
  ['&Zeta;', '&#918;', true, 'Zeta'],
  ['&Eta;', '&#919;', true, 'Eta'],
  ['&Theta;', '&#920;', true, 'Theta'],
  ['&Iota;', '&#921;', true, 'Iota'],
  ['&Kappa;', '&#922;', true, 'Kappa'],
  ['&Lambda;', '&#923;', true, 'Lambda'],
  ['&Mu;', '&#924;', true, 'Mu'],
  ['&Nu;', '&#925;', true, 'Nu'],
  ['&Xi;', '&#926;', true, 'Xi'],
  ['&Omicron;', '&#927;', true, 'Omicron'],
  ['&Pi;', '&#928;', true, 'Pi'],
  ['&Rho;', '&#929;', true, 'Rho'],
  ['&Sigma;', '&#931;', true, 'Sigma'],
  ['&Tau;', '&#932;', true, 'Tau'],
  ['&Upsilon;', '&#933;', true, 'Upsilon'],
  ['&Phi;', '&#934;', true, 'Phi'],
  ['&Chi;', '&#935;', true, 'Chi'],
  ['&Psi;', '&#936;', true, 'Psi'],
  ['&Omega;', '&#937;', true, 'Omega'],
  ['&alpha;', '&#945;', true, 'alpha'],
  ['&beta;', '&#946;', true, 'beta'],
  ['&gamma;', '&#947;', true, 'gamma'],
  ['&delta;', '&#948;', true, 'delta'],
  ['&epsilon;', '&#949;', true, 'epsilon'],
  ['&zeta;', '&#950;', true, 'zeta'],
  ['&eta;', '&#951;', true, 'eta'],
  ['&theta;', '&#952;', true, 'theta'],
  ['&iota;', '&#953;', true, 'iota'],
  ['&kappa;', '&#954;', true, 'kappa'],
  ['&lambda;', '&#955;', true, 'lambda'],
  ['&mu;', '&#956;', true, 'mu'],
  ['&nu;', '&#957;', true, 'nu'],
  ['&xi;', '&#958;', true, 'xi'],
  ['&omicron;', '&#959;', true, 'omicron'],
  ['&pi;', '&#960;', true, 'pi'],
  ['&rho;', '&#961;', true, 'rho'],
  ['&sigmaf;', '&#962;', true, 'final sigma'],
  ['&sigma;', '&#963;', true, 'sigma'],
  ['&tau;', '&#964;', true, 'tau'],
  ['&upsilon;', '&#965;', true, 'upsilon'],
  ['&phi;', '&#966;', true, 'phi'],
  ['&chi;', '&#967;', true, 'chi'],
  ['&psi;', '&#968;', true, 'psi'],
  ['&omega;', '&#969;', true, 'omega'],
// symbols
  ['&alefsym;', '&#8501;', false, 'alef symbol'],
  ['&piv;', '&#982;', false, 'pi symbol'],
  ['&real;', '&#8476;', false, 'real part symbol'],
  ['&thetasym;', '&#977;', false, 'theta symbol'],
  ['&upsih;', '&#978;', false, 'upsilon - hook symbol'],
  ['&weierp;', '&#8472;', false, 'Weierstrass p'],
  ['&image;', '&#8465;', false, 'imaginary part'],
// arrows
  ['&larr;', '&#8592;', true, 'leftwards arrow'],
  ['&uarr;', '&#8593;', true, 'upwards arrow'],
  ['&rarr;', '&#8594;', true, 'rightwards arrow'],
  ['&darr;', '&#8595;', true, 'downwards arrow'],
  ['&harr;', '&#8596;', true, 'left right arrow'],
  ['&crarr;', '&#8629;', false, 'carriage return'],
  ['&lArr;', '&#8656;', false, 'leftwards double arrow'],
  ['&uArr;', '&#8657;', false, 'upwards double arrow'],
  ['&rArr;', '&#8658;', false, 'rightwards double arrow'],
  ['&dArr;', '&#8659;', false, 'downwards double arrow'],
  ['&hArr;', '&#8660;', false, 'left right double arrow'],
  ['&there4;', '&#8756;', false, 'therefore'],
  ['&sub;', '&#8834;', false, 'subset of'],
  ['&sup;', '&#8835;', false, 'superset of'],
  ['&nsub;', '&#8836;', false, 'not a subset of'],
  ['&sube;', '&#8838;', false, 'subset of or equal to'],
  ['&supe;', '&#8839;', false, 'superset of or equal to'],
  ['&oplus;', '&#8853;', false, 'circled plus'],
  ['&otimes;', '&#8855;', false, 'circled times'],
  ['&perp;', '&#8869;', false, 'perpendicular'],
  ['&sdot;', '&#8901;', false, 'dot operator'],
  ['&lceil;', '&#8968;', false, 'left ceiling'],
  ['&rceil;', '&#8969;', false, 'right ceiling'],
  ['&lfloor;', '&#8970;', false, 'left floor'],
  ['&rfloor;', '&#8971;', false, 'right floor'],
  ['&lang;', '&#9001;', false, 'left-pointing angle bracket'],
  ['&rang;', '&#9002;', false, 'right-pointing angle bracket'],
  ['&loz;', '&#9674;', true, 'lozenge'],
  ['&spades;', '&#9824;', true, 'black spade suit'],
  ['&clubs;', '&#9827;', true, 'black club suit'],
  ['&hearts;', '&#9829;', true, 'black heart suit'],
  ['&diams;', '&#9830;', true, 'black diamond suit'],
  // ['&ensp;',    '&#8194;', false,'en space'],
  // ['&emsp;',    '&#8195;', false,'em space'],
  // ['&thinsp;',  '&#8201;', false,'thin space'],
  // ['&zwnj;',    '&#8204;', false,'zero width non-joiner'],
  // ['&zwj;',     '&#8205;', false,'zero width joiner'],
  // ['&lrm;',     '&#8206;', false,'left-to-right mark'],
  // ['&rlm;',     '&#8207;', false,'right-to-left mark'],
  // ['&shy;',     '&#173;',  false,'soft hyphen']
];

export const Charmap = _charmap.map(function (val, key) {
  return {name: val[3], html_entity: val[0]};
});
